/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Detail_Applications_ColumnInputs */

const en_admin_company_detail_applications_column = /** @type {(inputs: Admin_Company_Detail_Applications_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications received`)
};

const de_admin_company_detail_applications_column = /** @type {(inputs: Admin_Company_Detail_Applications_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingegangene Bewerbungen`)
};

/**
* | output |
* | --- |
* | "Applications received" |
*
* @param {Admin_Company_Detail_Applications_ColumnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_detail_applications_column = /** @type {((inputs?: Admin_Company_Detail_Applications_ColumnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Detail_Applications_ColumnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_detail_applications_column(inputs)
	return en_admin_company_detail_applications_column(inputs)
});